import { MenuItem } from "@mui/material";
import { colorPrimary } from "@/constants/colors";
import { TCustomMenuItemProps } from "./CustomMenuItem.props";

const CustomMenuItem = ({ ...props }: TCustomMenuItemProps): JSX.Element => {
	return <MenuItem {...props} sx={{ fontSize: 13, color: colorPrimary, ...props.sx }} />;
};

export default CustomMenuItem;
